import FingerprintJS from "@fingerprintjs/fingerprintjs";

export const getDeviceCode = (callback: Function): Promise<string> => {
    FingerprintJS.load().then(fp => {
        fp.get().then(result => {
            let extendedComponents = result.components;
            extendedComponents.languages = {};
            extendedComponents.audio = {};
            extendedComponents.domBlockers = {};
            extendedComponents.fontPreferences = {};
            extendedComponents.fonts = {};
            extendedComponents.screenFrame = {};
            extendedComponents.canvas = {};
            extendedComponents.colorDepth = {};
            extendedComponents.screenResolution = {};
            extendedComponents.timezone = {};
            extendedComponents.vendorFlavors = {};
            extendedComponents.cookiesEnabled = {};
            extendedComponents.colorGamut = {};
            extendedComponents.hdr = {};
            extendedComponents.math.duration = {};
            extendedComponents.webGlBasics.duration = {};
            extendedComponents.cpuClass = {};
            extendedComponents.webGlExtensions.value.parameters = extendedComponents.webGlExtensions.value.parameters.map(
                param => {
                    // 替换STENCIL相关参数的值为固定值
                    return param
                        .replace(/STENCIL_BACK_VALUE_MASK=36004=\d+/g, "STENCIL_BACK_VALUE_MASK=36004=")
                        .replace(/STENCIL_BACK_WRITEMASK=36005=\d+/g, "STENCIL_BACK_WRITEMASK=36005=")
                        .replace(/STENCIL_VALUE_MASK=2963=\d+/g, "STENCIL_VALUE_MASK=2963=")
                        .replace(/STENCIL_WRITEMASK=2968=\d+/g, "STENCIL_WRITEMASK=2968=");
                }
            );
            extendedComponents.webGlExtensions.duration = 0;

            const visitorId = FingerprintJS.hashComponents(extendedComponents);
            // console.log('visitorId:', visitorId);
            // console.log(JSON.stringify(extendedComponents));
            if (callback) {
                callback(visitorId);
            }
        });
    });
};
